import { render, staticRenderFns } from "./MyCourseCard.vue?vue&type=template&id=c4fcf990&scoped=true"
import script from "./MyCourseCard.vue?vue&type=script&lang=js"
export * from "./MyCourseCard.vue?vue&type=script&lang=js"
import style0 from "./MyCourseCard.vue?vue&type=style&index=0&id=c4fcf990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fcf990",
  null
  
)

export default component.exports